import { createTheme } from '@mui/material/styles';

export const uicolors = {
  black: {
    '50': '#fafafa',
    '100': '#f4f5f5',
    '200': '#e3e5e8',
    '300': '#d3d6d9',
    '400': '#9fa6ac',
    '500': '#6f767c',
    '600': '#50575d',
    '700': '#3e4347',
    '800': '#26292b',
    '900': '#17191b',
    '950': '#090a0b',
  },
  blueNav: {
    '50': '#eaf7ff',
    '100': '#d1ecff',
    '200': '#addfff',
    '300': '#74ccff',
    '400': '#33b0ff',
    '500': '#048cff',
    '600': '#007aff',
    '700': '#006dff',
    '800': '#0056d9',
    '900': '#0048aa',
    '950': '#052a63',
  },
  blue: {
    '50': '#eef4ff',
    '100': '#d9e6ff',
    '200': '#bcd4ff',
    '300': '#8eb9ff',
    '400': '#5994ff',
    '500': '#4178ff',
    '600': '#1b4cf5',
    '700': '#1437e1',
    '800': '#172eb6',
    '900': '#192d8f',
    '950': '#141d57',
  },
  green: {
    '50': '#edffee',
    '100': '#d6ffda',
    '200': '#afffb8',
    '300': '#71ff82',
    '400': '#2dfb47',
    '500': '#02e51f',
    '600': '#00bf18',
    '700': '#009e15',
    '800': '#067515',
    '900': '#085f16',
    '950': '#003609',
  },
  gold: {
    '50': '#f7f5ef',
    '100': '#eae5d8',
    '200': '#d7cdb4',
    '300': '#c1af88',
    '400': '#a9905f',
    '500': '#9a8154',
    '600': '#826845',
    '700': '#675139',
    '800': '#574434',
    '900': '#4c3c30',
    '950': '#2b2018',
  },
};

export const muiTheme = createTheme({
  typography: {
    h1: {
      color: uicolors.blueNav[950],
    },
    h2: {
      color: uicolors.blueNav[950],
    },
    h3: {
      color: uicolors.blueNav[950],
    },
    h4: {
      color: uicolors.blueNav[950],
    },
    h5: {
      color: uicolors.blueNav[950],
    },
    h6: {
      color: uicolors.blueNav[950],
    },
  },
  palette: {
    text: {
      primary: '#434A51',
      secondary: '#717171',
    },
    background: {
      default: '#f1f1f1',
    },
    primary: {
      main: uicolors.blue[500],
    },
    secondary: {
      main: uicolors.green[700],
    },
    info: {
      main: uicolors.blue[500],
    },
    success: {
      main: uicolors.green[700],
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        sizeSmall: {
          padding: 6,
        },
        head: {
          fontWeight: 600,
        },
        stickyHeader: {
          backgroundColor: '#fff',
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        color: 'primary',
      },
      styleOverrides: {
        root: {
          border: '1px solid #00000011',
          borderRadius: 14,
        },
        sizeMedium: {
          borderRadius: 10,
        },
        sizeSmall: {
          borderRadius: 8,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        actions: {
          color: uicolors.blue[500],
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&:nth-of-type(odd)': {
            backgroundColor: '#FCFCFC',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.search-field': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: uicolors.blue[700],
            },
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiAlertTitle: {
      defaultProps: {
        sx: {
          fontWeight: 600,
        },
      },
    },
  },
});

export const appTheme = {
  drawerWidth: 280,
};
